import { render, staticRenderFns } from "./TestTaskForm.vue?vue&type=template&id=adcf13f8"
import script from "./TestTaskForm.vue?vue&type=script&lang=js"
export * from "./TestTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports